/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash'
import React, { FC, ReactElement } from 'react'
import InputMask from 'react-input-mask'
import { Container, InputElement, Outside } from './styles'

export type Form = {
  dirty: boolean;
  touched: { [key: string]: boolean };
  errors: { [key: string]: boolean };
  setFieldValue: (name: string, value: any) => void;
}

export type Field = {
  name: string;
  type?: string;
  value?: any;
  onChange?: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
  };
  onBlur?: (e: any) => any;
}

export type InputProps = {
  field?: Field;
  form?: Form;
  label?: string;
  value?: string;
  type?: 'text' | 'password' | 'email' | 'tel' | 'textarea';
  size?: 'md' | 'lg' | 'sm';
  id?: string;
  name?: string;
  info?: string | ReactElement | ReactElement[];
  rightAttachment?: string | ReactElement | ReactElement[];
  maxLength?: number;
  mask?: string;
  placeholder?: string;
  onChange?: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
  };
  onBlur?: (e: any) => any;
  onFocus?: (e: any) => any;
  onClick?: (e: any) => any;
}

const Input: FC<InputProps> = ({
  field,
  form,
  info,
  id,
  label,
  value,
  type,
  name: _name,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onClick,
  rightAttachment,
  maxLength,
  mask
}): ReactElement => {
  const name = field?.name || _name || ''

  const errorMessage = name ? get(form?.errors, name) : null
  const touched = name ? get(form?.touched, name) : null
  const error = touched && errorMessage

  return (
    <Outside className='input'>
      <Container $error={!!error}>
        {mask
          ? (
            <InputMask
              mask={mask}
              value={field?.value || value || ''}
              onChange={field?.onChange || onChange}
              onBlur={field?.onBlur || onBlur}
              maskChar={null}
            >
              {(inputProps: any) => (
                <InputElement
                  {...inputProps}
                  id={id}
                  $error={!!error}
                  name={name}
                  value={field?.value || value || ''}
                  maxLength={maxLength}
                  placeholder={placeholder}
                  type={type}
                />
              )}
            </InputMask>
          )
          : (
            <InputElement
              id={id}
              $error={!!error}
              name={name}
              value={field?.value || value || ''}
              onChange={field?.onChange || onChange}
              onBlur={field?.onBlur || onBlur}
              onFocus={onFocus}
              onClick={onClick}
              placeholder={placeholder}
              maxLength={maxLength}
              type={type}
            />
          )}
        {label && <label>{label}</label>}
        {rightAttachment && <div className='right_attachment'>{rightAttachment}</div>}
      </Container>
      {error && <span className='error'>{error}</span>}
      {info && <span className='info'>{info}</span>}
    </Outside>
  )
}

export default Input
